import { render, staticRenderFns } from "./activatedGame.vue?vue&type=template&id=974f70ee"
import script from "./activatedGame.vue?vue&type=script&lang=js"
export * from "./activatedGame.vue?vue&type=script&lang=js"
import style0 from "./activatedGame.vue?vue&type=style&index=0&id=974f70ee&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports